import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'rebass'

const Brand = props => (
  <NavLink {...props} is={Link} to="/" alt={props.brand} fontSize={[3, 4, 5]} />
)

Brand.propTypes = {
  brand: PropTypes.string,
}

export default Brand



// WEBPACK FOOTER //
// ./src/containers/Layout/Header/Brand.js